import User from './User';
import Anonymous from './Anonymous';
import Registered from './Registered';
import Verified from './Verified';
import Product from './Product';
import Lattice from './Lattice';
import Reducer from './Reducer';
import Logged_User from './Logged_User';
import Password from './Password';
import Locale from './Locale';
import Short_Purchase from './Short_Purchase';
import Gender from './Gender';
import Register_Country from './Register_Country';
import Pin from './Pin';
import Mobile from './Mobile';
import Purchase from './Purchase';
import Order from './Order';
import Behaviour from './Behaviour';
import Behaviour_Response from './Behaviour_Response';
import Email from './Email';
import UUID from './UUID';
import Datetime from './Datetime';
import values from 'lodash/object/values';
import t from 'tcomb';

// Dato un server che contiene le api di comunicazione grezze
// aggiunge agli oggetti di dominio delle api chiare e comode da usare
export default function attach_server(server: t.Object) {

  // Restituisce l'utente corrente
  User.load = function(callback: t.Function) {
    server.load_user({}, function(err, user) {
      if (err) {
        callback(err);
      } else {
        callback(null, User.of(user));
      }
    });
  };

  function do_change_password(old_password: Password, new_password: Password, callback: t.Function) {
    server.do_change_password({
      oldPassword: old_password,
      newPassword: new_password
    }, function(err) {
      callback(err);
    });
  }

  function do_logout(callback: t.Function) {
    server.do_logout({}, function(err, user) {
      if (err) {
        callback(err);
      } else {
        var anonymous = Anonymous(user);
        callback(null, anonymous);
      }
    });
  }

  function do_accept_rcs_privacy(callback: t.Function) {
    server.do_accept_rcs_privacy({}, function(err, user) {
      if (err) {
        callback(err);
      } else {
        user.com_locale = Locale.of(user.com_locale);
        user = Logged_User(User(user));
        callback(null, user);
      }
    });
  }

  // Registra un nuovo utente
  Anonymous.prototype.do_register = function(email: Email, locale: Locale, privacy_rcs: ?t.String, privacy_other: ?t.String, privacy_tracking: ?t.String, callback: t.Function) {
    server.do_register({
      emailAddress: email,
      com_locale: String(locale),
      privacy_rcs: privacy_rcs,
      privacy_other: privacy_other,
      privacy_tracking: privacy_tracking
    }, callback);
  };

  // Reset password di un utente che se l'è dimenticata
  Anonymous.prototype.do_resend_password = function(email: Email, callback: t.Function) {
    server.do_resend_password({
      emailAddress: email
    }, callback);
  };

  // Login
  Anonymous.prototype.do_login = function(email: Email, password: Password, callback: t.Function) {
    server.do_login({
      emailAddress: email,
      password: password
    }, function(err, user) {
      if (err) {
        callback(err, null);
      } else {
        user.com_locale = Locale.of(user.com_locale);
        user = Logged_User(User(user));
        callback(null, user);
      }
    });
  };

  // Resituisce l'url da raggiungere per poter effettuare la login con facebook
  Anonymous.prototype.load_facebook = function(target: t.String, locale: Locale, callback: t.Function) {
    server.load_facebook({
      target: target,
      com_locale: String(locale)
    }, function(err, obj: ?t.Object) {
      if (err) {
        callback(err);
      } else {
        t.assert(t.String.is(obj.loginUri));
        callback(null, obj.loginUri);
      }
    });
  };

  // Resituisce l'url da raggiungere per poter effettuare la login con google
  Anonymous.prototype.load_google = function(target: t.String, locale: Locale, callback: t.Function) {
    server.load_google({
      target: target,
      com_locale: String(locale)
    }, function(err, obj: ?t.Object) {
      if (err) {
        callback(err);
      } else {
        t.assert(t.String.is(obj.loginUri));
        callback(null, obj.loginUri);
      }
    });
  };

  // Resituisce l'url da raggiungere per poter effettuare la login con google
  Anonymous.prototype.load_microsoft = function(target: t.String, locale: Locale, callback: t.Function) {
    server.load_microsoft({
      target: target,
      com_locale: String(locale)
    }, function(err, obj: t.Object) {
      if (err) {
        callback(err);
      } else {
        t.assert(t.String.is(obj.loginUri));
        callback(null, obj.loginUri);
      }
    });
  };

  // Resituisce l'url da raggiungere per poter effettuare la login con google
  Anonymous.prototype.load_twitter = function(target: t.String, locale: Locale, lattice_id: ?UUID, callback: t.Function) {
    server.load_twitter({
      target: target,
      com_locale: String(locale),
      lattice_id: lattice_id
    }, function(err, obj: ?t.Object) {
      if (err) {
        callback(err);
      } else {
        t.assert(t.String.is(obj.loginUri));
        callback(null, obj.loginUri);
      }
    });
  };

  // Cambiamento password per l'utente vver
  Registered.prototype.do_change_password = do_change_password;
  // Logut per l'utente Registered
  Registered.prototype.do_logout = do_logout;
  // do_accept_rcs_privacy per l'utente Registered
  Registered.prototype.do_accept_rcs_privacy = do_accept_rcs_privacy;

  // # Processo di verifica

  // Richiesta pin
  Registered.prototype.do_request_pin = function(country: Register_Country, mobile: Mobile, callback: t.Function) {
    server.do_request_pin({
      mobileCountry: country,
      mobileNumber: mobile
    }, callback);
  };

  // Inserimento pin
  Registered.prototype.do_insert_pin = function(pin: Pin, callback: t.Function) {
    server.do_insert_pin({
      pin: pin
    }, callback);
  };

  // Conclusione del processo di verifica
  Registered.prototype.do_verify = function(gender: Gender, birth_date: Datetime, country: Register_Country, district: t.String, zip: t.String, callback: t.Function) {
    server.do_verify({
      gender: gender,
      birth_date: birth_date,
      country: country,
      district: district,
      zip: zip
    }, function(err, user) {
      if (err) {
        callback(err, null);
      } else {
        user.com_locale = Locale.of(user.com_locale);
        const verified = new Verified(user);
        callback(null, verified);
      }
    });
  };

  // Cambiamento password per l'utente Verified
  Verified.prototype.do_change_password = do_change_password;
  // Logut per l'utente Verified
  Verified.prototype.do_logout = do_logout;
  // do_accept_rcs_privacy per l'utente Verified
  Verified.prototype.do_accept_rcs_privacy = do_accept_rcs_privacy;

  // Carica le info sommarie degli acquisti di un utente
  function load_purchases(callback: t.Function) {
    server.load_purchases({}, function(err, purchases: ?t.Object) {
      if (err) {
        callback(err, null);
      } else {
        purchases = values(purchases).map(Short_Purchase);
        callback(null, purchases);
      }
    });
  }

  Registered.prototype.load_purchases = load_purchases;
  Verified.prototype.load_purchases = load_purchases;

  Verified.prototype.share_purchase = function(product_id: t.String, callback: t.Function) {
    server.do_share_purchase({
      product_id: product_id
    }, callback);
  };

  // Carica le info complete di un acquisto di un utente
  function load_purchase(purchase_id: UUID, target: t.String, cancel_target: t.String, callback: t.Function) {
    server.load_purchase({
      purchase_id: purchase_id,
      target: target,
      cancel_target: cancel_target
    }, function(err, purchase) {
      if (err) {
        callback(err, null);
      } else {
        callback(null, Purchase(purchase));
      }
    });
  }

  Registered.prototype.load_purchase = load_purchase;
  Verified.prototype.load_purchase = load_purchase;

  Verified.prototype.do_update_account = function(name: ?t.String, surname: ?t.String, gender: Gender, birth_date: Datetime, country: Register_Country, district: t.String, zip: t.String, com_locale: Locale, callback: t.Function) {
    server.do_update_account({
      name: name || '',
      surname: surname || '',
      gender: gender,
      birth_date: birth_date,
      country: country,
      district: district,
      zip: zip,
      com_locale: String(com_locale)
    }, function(err, user: ?t.Object) {
      if (err) {
        callback(err, null);
      } else {
        user.com_locale = Locale.of(user.com_locale);
        const verified = new Verified(user);
        callback(null, verified);
      }
    });
  };

  // L'utente acquista il prodotto
  function do_approve_order(product: Product, order: Order, callback: t.Function) {
    server.do_approve_order({
      product_id: product.id,
      price: product.runtime.price,
      order: order
    }, function(err, result: ?t.Object) {
      if (err) {
        callback(err);
      } else {
        t.assert(UUID.is(result.purchase_id));
        t.assert(t.Object.is(result.runtime));
        callback(null, {
          purchase_id: result.purchase_id,
          product: product.replace_runtime(result.runtime)
        });
      }
    });
  }

  Registered.prototype.do_approve_order = do_approve_order;
  Verified.prototype.do_approve_order = do_approve_order;

  // L'utente invia il codice sconto di madai
  function do_send_gift_card_code(purchase_id: UUID, target: t.String, cancel_target: t.String, gift_card_code: t.String, callback: t.Function) {
    server.do_send_gift_card_code({
      purchase_id: purchase_id,
      target: target,
      cancel_target: cancel_target,
      gift_card_code: gift_card_code
    }, function(err, result: ?t.Object) {
      if (err) {
        callback(err);
      } else {
        callback(null, {
          purchase_id: result.id
        });
      }
    });
  }

  Registered.prototype.do_send_gift_card_code = do_send_gift_card_code;
  Verified.prototype.do_send_gift_card_code = do_send_gift_card_code;

  // Carica il runtime di un prodotto per l'utente corrente
  Product.prototype.load_runtime = function(callback: t.Function) {
    var product = this;
    server.load_runtime({
      product_id: product.id
    }, function(err, runtime) {
      if (err) {
        callback(err);
      } else {
        callback(null, product.replace_runtime(runtime));
      }
    });
  };

  // Carica un reticolo by id
  Lattice.load = function(lattice_id: UUID, callback: t.Function) {
    server.load_lattice({
      lattice_id: lattice_id
    }, function(err, lattice) {
      if (err) {
        callback(err);
      } else {
        callback(null, Lattice.of(lattice));
      }
    });
  };

  // Segnala al server il completamento di un reducer
  Reducer.do_reduce = function(product_id: UUID, behaviour: ?Behaviour, callback: t.Function) {
    server.do_reduce({
      product_id: product_id,
      behaviour: behaviour
    }, function(err, result) {
      if (err) {
        callback(err);
      } else {
        callback(null, Behaviour_Response(result));
      }
    });
  };

}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/attach_server.js
 **/